<template>
  <div>
    <!-- :cell-style="{ background: 'white', padding: '3px 0' }" -->
    <!-- :header-cell-style="{ background: 'white', color: '#555', padding: '3px 0' }"  -->

    <!-- :data="tableData.filter(data => !search || data.specialty_name.toLowerCase().includes(search.toLowerCase()))" -->
    <el-table height="297" :data="tableData" style="width: 100%" class="el-table" :row-class-name="tableRowClassName"
      :header-cell-style="{ background: 'white', color: '#555', padding: '3px 0' }" :cell-style="{ padding: '3px 0' }"
      border>
      <div slot="empty" class="empty">
        <span>该专业在本年度可能未在豫招生</span>
      </div>
      <el-table-column prop="specialty_name" label="专业名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="plan_num" label="计划" width='50' align="center">
        <template slot-scope="scope">
          {{ scope.row.plan_num | changeZero }}
        </template>
      </el-table-column>

      <el-table-column prop="max_score" label="最高分" show-overflow-tooltip width='70' align="center">
        <template slot-scope="scope">
          {{ scope.row.max_score | changeZero }}
        </template>
      </el-table-column>
      <el-table-column prop="mean_score" label="平均分" show-overflow-tooltip width='70' align="center">
        <template slot-scope="scope">
          {{ scope.row.mean_score | changeZero }}
        </template>
      </el-table-column>
      <el-table-column prop="mean_score" label="最低分" show-overflow-tooltip width='70' align="center">
        <template slot-scope="scope">
          {{ scope.row.min_score | changeZero }}
        </template>
      </el-table-column>
      <el-table-column prop="min_score" label="位次" show-overflow-tooltip width='70' align="center">
        <template slot-scope="scope">
          {{ scope.row.ranking | changeZero }}
        </template>
      </el-table-column>
      <el-table-column prop="min_score" label="省控线差" show-overflow-tooltip width='50' align="center">
        <template slot-scope="scope">
          {{ Number(scope.row.min_score) ? Number(scope.row.min_score) - Number(line) : '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="min_score" label="院校分差" show-overflow-tooltip width='50' align="center">
        <template slot-scope="scope">
          {{ Number(scope.row.min_score) ? Number(scope.row.min_score) - collegeData['min_score_' + status] : '-' }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    tableData: Array,
    search: String,
    // score: Number,
    line: Number,
    collegeData: Object,
    status: Number
  },
  methods: {
    tableRowClassName({ row }) {
      if (this.search) {
        if (row.specialty_name.includes(this.search)) {
          return 'warning-row';
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  }
};
</script>
<style>
.el-table .warning-row {
  background: oldlace !important;
}

.el-table .success-row {
  background: #f0f9eb !important;
}
</style>


<style scoped lang='less'></style>
